"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";
import { useFlipCard } from "./useFlipCard";
export function PartnerMaifCard() {
  const $ = _c(31);
  const {
    isFlipped,
    toggle
  } = useFlipCard();
  const t = useTranslations("contact.partners.maif");
  const t0 = isFlipped ? "z-50" : "z-0";
  let t1;
  if ($[0] !== t0) {
    t1 = clsx("group relative w-full h-16 md:h-20 [perspective:1000px] cursor-pointer", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("clickToFlip");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isFlipped && "[transform:rotateY(180deg)]";
  let t4;
  if ($[4] !== t3) {
    t4 = clsx("relative w-full h-full transition-all duration-700 [transform-style:preserve-3d]", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("alt");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="absolute inset-0 [backface-visibility:hidden] bg-white-cream/50 rounded-xl border border-forest-green/5 flex items-center justify-center overflow-hidden p-2 group-hover:bg-white-cream transition-colors"><Image src="/images/partners/Maif-Logo.png" alt={t5} width={300} height={120} className="w-full h-full object-contain" /></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("memberNumber");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <p className="text-[10px] xs:text-[9px] font-medium text-forest-green leading-tight">{t7}{t8}8317209D</p>;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("insurance");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <p className="text-[9px] xs:text-[8px] font-medium text-forest-green leading-tight mt-1">{t10}</p>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <div className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] bg-white-cream rounded-xl border border-forest-green/20 flex flex-col items-center justify-center shadow-sm p-1 text-center">{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t4 || $[24] !== t6) {
    t13 = <div className={t4}>{t6}{t12}</div>;
    $[22] = t12;
    $[23] = t4;
    $[24] = t6;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t1 || $[27] !== t13 || $[28] !== t2 || $[29] !== toggle) {
    t14 = <div className={t1} onClick={toggle} title={t2}>{t13}</div>;
    $[26] = t1;
    $[27] = t13;
    $[28] = t2;
    $[29] = toggle;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}